"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _Mediator = _interopRequireDefault(require("../../../Mediator"));
var _ = _interopRequireDefault(require("../.."));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var InvokeSubMediator = function InvokeSubMediator(props) {
  var completedMessage = props.completedMessage,
    flowList = props.flowList,
    lockedMessage = props.lockedMessage,
    settings = props.settings;
  if (completedMessage) {
    return /*#__PURE__*/_react["default"].createElement("div", null, completedMessage);
  }
  if (lockedMessage) {
    return /*#__PURE__*/_react["default"].createElement("div", null, lockedMessage);
  }
  var SelectedMediator = _Mediator["default"];
  var mediatorProps = !Array.isArray(settings.navigationSettings) ? settings.navigationSettings : {};
  var language = flowList.length ? flowList[0].language : '';
  var currentNavigation = _["default"].find(function (item) {
    return item.handle === settings.navigation;
  });
  if (currentNavigation && currentNavigation.handle !== 'noSidebar') {
    SelectedMediator = currentNavigation.mediatorComponent;
  }
  return /*#__PURE__*/_react["default"].createElement(SelectedMediator
  // onAssignmentComplete already called in useCourseWrapperMediator
  , _extends({}, (0, _omit2["default"])(props, ['onAssignmentComplete', 'onComplete']), {
    allowRetake: settings.allowRetake,
    flowList: flowList,
    language: language,
    mediatorProps: mediatorProps,
    courseWrapperMediatorProps: props.mediatorProps
  }));
};
var _default = exports["default"] = InvokeSubMediator;